import React from 'react'
import { Box } from '@mui/material'
import BookRequest from '../Components/Homepage/BookRequest'
import ServiceInfo3rd from '../Components/Homepage/ServiceInfo3rd'
import Statistics from '../Components/Homepage/Statistics'
import FlightFrom from '../Components/Homepage/FlightFrom'
import Awards from '../Components/Homepage/Awards'
import ChairmanMsg from '../Components/Homepage/ChairmanMsg'
import FeatureCards from '../Components/Homepage/FeatureCards'
import SliderHome from '../Components/Homepage/SliderHome'
import BelowHomeslider from '../Components/Homepage/BelowHomeslider'
// import ReviewsGoogle from '../Components/Homepage/ReviewsGoogle'
// import TypeWriterEffect from './TypeWriterEffect'

const HomePage = () => {
  return (
    <>
      <Box className='coverBox'>
        <Box className="boxLayer">
          <SliderHome />
          {/* <Container >
            <Row>
              <Col className='coverText' lg={6} md={6} sm={12}>
                <motion.div 
                    initial={{ opacity: 0.5, x: -200 }} 
                    whileInView={{ opacity: 1, x: 0 }} 
                    transition={{ duration: 1, ease: "easeInOut"  }} 
                    viewport={{ once: true }} 
                  >
                <Typography variant="subtitle1" color="">Welcome To <span>shankh</span> <span>air</span></Typography>
                <Typography variant="h2" color="">Save Time & Fly with Comfort</Typography>
                 <TypeWriterEffect /> 
                <Typography variant="body2">Shankh Air, poised to be Uttar Pradesh’s inaugural scheduled airline, is gearing up to enhance connectivity across India.</Typography>
                <Box className="coverBtns d-flex gap-5">
                  <div className='btnWrapper'>
                    <Button variant="link" className="coverBtn bg-orange btnIcon"><span>Book Now <FontAwesomeIcon icon={faPlaneDeparture} /></span></Button>
                  </div>
                  <div className='btnWrapper'>
                    <Button variant="link" className="coverBtn bg-green"><span>Read More</span></Button>
                  </div>
                </Box>
                </motion.div>
              </Col>
              <Col lg={6} md={6} sm={12} className='coverImg'>
                <motion.div 
                    initial={{ opacity: 0, x: 200 }} 
                    whileInView={{ opacity: 1, x: 0 }} 
                    transition={{ duration: 1, ease: "easeInOut"  }} 
                    viewport={{ once: false }} 
                  >
                    <Image src={planeCover} className='img-fluid'></Image>
                </motion.div>
              </Col>
            </Row>
          </Container> */}
        </Box>
      </Box>
      {/* below the cover slider component */}
      <BelowHomeslider />
      {/* ticket booking componetn */}
      <BookRequest />
      {/* service info component */}
      <ServiceInfo3rd />
      {/* statistics count component */}
      <Statistics />
      {/* flight from different cities */}
      <FlightFrom />
      {/* customer reviews */}
      {/* <ReviewsGoogle /> */}
      {/* Awards section */}
      <Awards />
      {/* Chairman message part */}
      <ChairmanMsg />
      {/* Features cards section */}
      <FeatureCards />
    </>
  )
}

export default HomePage
